/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WhitelabelSettingReadModel
 */
export interface WhitelabelSettingReadModel {
    /**
     * 
     * @type {string}
     * @memberof WhitelabelSettingReadModel
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelSettingReadModel
     */
    defaultValue: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelSettingReadModel
     */
    customValue: string;
}

/**
 * Check if a given object implements the WhitelabelSettingReadModel interface.
 */
export function instanceOfWhitelabelSettingReadModel(value: object): value is WhitelabelSettingReadModel {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    if (!('customValue' in value) || value['customValue'] === undefined) return false;
    return true;
}

export function WhitelabelSettingReadModelFromJSON(json: any): WhitelabelSettingReadModel {
    return WhitelabelSettingReadModelFromJSONTyped(json, false);
}

export function WhitelabelSettingReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WhitelabelSettingReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'defaultValue': json['defaultValue'],
        'customValue': json['customValue'],
    };
}

export function WhitelabelSettingReadModelToJSON(json: any): WhitelabelSettingReadModel {
    return WhitelabelSettingReadModelToJSONTyped(json, false);
}

export function WhitelabelSettingReadModelToJSONTyped(value?: WhitelabelSettingReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'defaultValue': value['defaultValue'],
        'customValue': value['customValue'],
    };
}

